import { render } from "./PwChangeForm.vue?vue&type=template&id=7d28d702"
import script from "./PwChangeForm.vue?vue&type=script&lang=js"
export * from "./PwChangeForm.vue?vue&type=script&lang=js"
script.render = render

export default script